<template>
  <div>
    <div class="showlabel">
      <h4>选择题库</h4>
      <!-- <div class="testtype">组件模式：{{ groupmode }}</div>
      <div class="testtype">命题方式：{{ unified }}</div> -->
      <div class="testtype" @click="addquestionbank">添加题库</div>
    </div>
    <div class="baic_content">
      <!-- 添加题库按钮 -->
      <div v-if="isaddtest">
        <div class="addtestbtn">
          <div class="addtestbtncontent1" @click="addquestionbank"></div>
        </div>
        <h4>添加题库</h4>
      </div>
      <!-- 题库列表 -->
      <Eldialog ref="addtestdialog" @totesttype="totesttypedata"></Eldialog>
      <!-- 试题设置弹窗 -->
      <!-- <TwoSon ref="addtextSon" /> -->
      <div v-if="!isaddtest">
        <div class="testtypebutton">
          <!-- 切换按钮 -->
          <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '1' }"
            @click="changetesttype('1')"
          >
            平台题库
          </button>
          <!-- <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '0' }"
            @click="changetesttype('0')"
          >
            自定义题库
          </button> -->
        </div>
        <div class="testtypebutton_content">
          <div class="seriesof">
            <h4>已选系列</h4>
            <div class="seriesofbtnac">
              <div
                class="seriesofbtn"
                v-for="(item, index) in seriesof"
                :key="index"
              >
                <button
                  :class="{ isselect: cssisselect0 === index }"
                  @click="isselect0(index)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
          </div>
          <div class="seriesof">
            <h4>已选类别</h4>
            <div class="seriesofbtnac">
              <div
                class="seriesofbtn"
                v-for="(item, index) in category"
                :key="index"
              >
                <button
                  :class="{ isselect: cssisselect1 === index }"
                  @click="isselect1(index)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
          </div>
          <div class="seriesof">
            <h4>已选科目</h4>
            <div class="seriesofbtnac">
              <div
                class="seriesofbtn"
                v-for="(item, index) in subjects"
                :key="index"
              >
                <button
                  :class="{ isselect: cssisselect2 === index }"
                  @click="isselect2(index, item.AppEName)"
                >
                  {{ item.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 选择试题列表 -->
        <div class="question_content">
          <h4 class="select">选择题库</h4>
          <div class="question_contents">
            <div class="questions">
              <h5>平台题库</h5>
              <el-cascader-panel
                :options="options"
                :props="props"
                ref="cascader"
                :key="keyValuecascader"
                v-model="valsss"
                class="taansfer"
                @change="ishowselectChapter"
              >
                <template slot-scope="{ data }">
                  <span>{{ data.Name + `(${data.TestCount}题)` }}</span>
                  <!-- <span v-if="!node.isLeaf">
                    ({{ data.Childs.length }})
                  </span> -->
                </template>
              </el-cascader-panel>
            </div>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button
          class="succ_btn"
          @click="
            cutcoms(0);
            destroy();
          "
          >上一步</el-button
        >
        <el-button type="success" class="submit_btn" @click="nexttothree"
          >下一步</el-button
        >
      </div>
    </div>
    <!-- 弹窗 -->
  </div>
</template>

<script>
import Eldialog from "@/views/theonlineTest/published/components/newaddpaper/components/TwoPup.vue";
import qusetionfcuntion from "@/api/questionbank";
//import TwoSon from "./TwoSon.vue";
export default {
  props: ["cutcoms"],
  components: {
    Eldialog,
    // TwoSon,
  },
  data() {
    return {
      valsss: [], //选择框动态数据》
      isaddtest: true, //添加题库按钮的显示与隐藏true就是显示，false就是隐藏
      testtype: "1",
      keyValuecascader: 0,
      props: {
        multiple: true,
        label: "Name",
        value: "ID", //这里的value值主要是在切换动态ID的时候防止同名的试卷勾选重复的问题。
        // level: "ID",
        children: "Childs",
        disabled: "disable",
      },
      isaddnewcope: 0, //是否是新范围模式0是非新增 1是新增模式。  ** 备用数据
      isableoptions: "", //权重组卷返回需要禁用的数据
      isaddnewselectChapter: {}, //新范围模式下新增的权重，新增和修改都回传
      selectChapter: {}, //选取的章节  这是要发送的章节。 ④部生成的需要的数据
      selelctChapterone: "", //当前点击的第三级，已选科目的AppEname
      cssisselect0: "",
      cssisselect1: "",
      cssisselect2: "",
      SelectedApp: "", //选中的全体章数据 ④部生成的需要的数据
      groupmode: "", //组卷模式
      unified: "", //统一命题
      alltest: "", //alltest
      seriesof: ["医学三基", "住院医师", "主任医师", "招聘考试", "私密题库"], //已选系列数据 第一层，第一层和第二层存在关联，
      category: [
        //已选类别  第二层
        "已选临床“三基”训练分册试题集",
        "主任医师",
        "招聘考试",
        "招聘考试",
      ],
      subjects: [], //已选科目  第三层是第二层点击后请求的数据
      options: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇", disable: true },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    totesttypedata(e, a) {
      //!!!!!!!!!!!!!!!!!!!!!第二次采用点击的方式，思想是点击第一级，第二级数据动态改变，第二级默认展示第一个，然后开始展示第三级。
      console.log(e);
      this.SelectedApp = a; //选中的全体不题型。
      console.log(this.SelectedApp);
      this.alltest = e;
      this.seriesof = e.map((item) => {
        return item.label; //弹窗弹，对三级数据的第一级进行初始化第一次显示，这个时候还不知道第二级数据是啥，只有任意点击了一个按钮之后，才会显示第二级数据。
      });
      this.isselect0(0);
      //  console.log(this.seriesof);
      this.category = e[0].children.map((item) => {
        //但是这里采用默认第一次选中第一个按钮，第二级菜单就展示的是第一级菜单点击第一个按钮的状态，
        return item.label;
      });
      this.isselect1(0);
      this.subjects = e[0].children[0].children.map((item) => {
        //这里也是采用默认第一次选中后的数据，第三级菜单就采用第二级选中后的数据，然后就显示第三级。  这里只有根据一层一层的index请求数据，。保留下来选中的index.  只有第三层的数据有变化，就筛选出第三层的数据，然后请求。
        return item;
      });
      this.isselect2(0, this.subjects[0].AppEName);
    },
    addquestionbank() {
      this.$refs.addtestdialog.dialogVisible = true; //开启弹窗
      //   this.isaddtest = false;  隐藏添加题库按钮 ，展示题库具体列表
      console.log(this.$refs.addtestdialog.dialogVisible);
    },
    // 试题设置弹窗
    addtextSon() {
      this.$refs.addtextSon.dialogVisibleSon = true; // 开启弹窗
      // console.log( this.$refs.addtextSon.dialogVisibleSon,'滴滴滴')
    },
    changetesttype(type) {
      if (this.testtype !== type) {
        if (this.testtype === "1") {
          this.testtype = "0";
        } else {
          this.testtype = "1";
        }
      }
    },
    isselect0(index) {
         //第一级按钮，按钮点击后标识为选中状态
      this.cssisselect0 = index;
      this.category = this.alltest[index]["children"].map((item) => {
        return item.label;
      });
      this.isselect1(0);
      //第一级按钮，按钮点击后标识为选中状态
      // this.cssisselect0 = index;
      console.log(this.category, this.alltest);
    },
    isselect1(index) {
      //第二级按钮，按钮点击后标识为选中状态
      this.cssisselect1 = index;
       this.subjects = this.alltest[this.cssisselect0].children[index].children;
      this.isselect2(
        0,
        this.alltest[this.cssisselect0].children[index].children[0].AppEName
      );
    },
    async isselect2(index, Ename) {
      this.cssisselect2 = index; //第三级按钮，按钮点击后标识为选中状态
      let res = await qusetionfcuntion.getChapterMenu(Ename);
      res.data.Data.Childs.map((item) => {
        item.Childs.map((zitem) => {
          zitem.Childs.map((xitem) => {
            xitem.Childs = undefined;
          });
        });
      });
      this.options = res.data.Data.Childs;
      this.valsss = this.selectChapter[Ename];
      if (this.selectChapter[`${Ename}`] === undefined) {
        this.selectChapter[`${Ename}`] = "";
      }
      this.selelctChapterone = Ename;
      //新增范围模式下，开始锁住一部分需要锁住的数据。并且创造新的请求数据
      if (this.isaddnewcope == 1) {
        if (this.isaddnewselectChapter[Ename] === undefined) {
          this.isaddnewselectChapter[Ename] = ""; //新请求的数据。
        }
        if (this.isableoptions[Ename] === undefined) {
          return;
        }
        let isabblearr = this.isableoptions[Ename].map((item) => {
          return item.ExamCptID;
        });
        console.log(isabblearr);
        console.log(this.options);
        this.options.map((item) => {
          item.Childs.map((zitem) => {
            zitem.Childs.map((xitem) => {
              if (
                isabblearr.findIndex((fitem) => {
                  return xitem.ID == fitem;
                }) != -1
              ) {
                xitem.TestCount = 0;
                xitem.disable = true;
              }
            });
          });
        });
      }
    },
    nexttothree() {
      let selectleafnode = [];
      let newdataselectChapter;

      try {
        newdataselectChapter = JSON.parse(JSON.stringify(this.selectChapter));
        for (let key in newdataselectChapter) {
          if (newdataselectChapter[key] == "") {
            newdataselectChapter[key] = undefined;
          } else {
            let select = newdataselectChapter[key].map((item) => {
              selectleafnode.push(item[2]);
              return item[2];
            });
            newdataselectChapter[key] = select;
          }
        }
      } catch (error) {
        console.log(error);
        this.$message.error("没有添加题库");
      }
      
        if (this.isaddtest !== true) {
          if (selectleafnode.length > 0) {
            this.$parent.pagetworeq1 = this.SelectedApp; //这里将数据发送给父组件
            this.$parent.pagetworeq2 = selectleafnode;
            this.$parent.pagetwodata = newdataselectChapter;
            this.cutcoms(2);
          } else {
            this.$message.error("没有添加题型");
          }
        } else {
          //  下面这些都是精准下一步的-------------------------------
        }
     
    },
    ishowselectChapter() {
      this.selectChapter[`${this.selelctChapterone}`] = this.valsss;
      console.log(this.selectChapter);
      if (this.isaddnewcope == 1) {
        //新增模式下增加新的数据。
        let selectleafnode = this.$refs["cascader"].getCheckedNodes(true);
        selectleafnode = selectleafnode.filter((item) => {
          console.log(item);
          return item.isDisabled == null;
        });
        let selectleafnodearr = selectleafnode.map((item) => {
          return item.data.ID;
        });
        this.isaddnewselectChapter[this.selelctChapterone] = selectleafnodearr;
        console.log(this.isaddnewselectChapter);
      }
    },
    destroy() {
      this.$destroy();
    },
  },
  activated() {
    if (this.isaddnewcope == 1) {
      console.log(
        "keepchufa 第二页的数据下面第三页",
        this.selectChapter,
        this.selelctChapterone
      );
      console.log(this.isaddnewselectChapter, "已经选择的数据");
      console.log(this.isaddnewcope, this.isableoptions);
      this.isselect2(this.cssisselect2, this.selelctChapterone);
    }
  },
  watch: {
    options(newVal) {
      this.keyValuecascader++; //只要监听到数据源发生变化 keyValuecascader就更改，从来改变级联的唯一渲染。
      console.log(this.keyValuecascader);
    },
  },
  created() {
    this.groupmode = this.$parent.testmode;
    // this.firstperform = 1;  //0代表第一次加载 1代表不是第一次加载
    this.unified = this.$parent.checkmode;
  },
};
</script>

<style lang="scss" scoped>
.baic_content {
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 14px 14px 14px 14px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 60px;
    background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  h4 {
    text-align: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #1890ff;
    cursor: pointer;
  }
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.addtestbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 370px;
  padding-top: 80px;
  background-color: #ffffff;
  & + h4 {
    background-color: #ffffff;
    padding-bottom: 100px;
  }
  .addtestbtncontent1 {
    width: 200px;
    height: 200px;
    background-image: url("../../../../assets/addtesttype.png");
    background-size: 100%;
    cursor: pointer;
    &:hover {
      width: 290px;
      height: 290px;
      background-image: url("../../../../assets/addtesttypeactive.png");
      background-size: 100%;
    }
  }
}
.testtypebutton {
  height: 93px;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.testtypebtn {
  width: 180px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #1890ff;
  font-family: PingFang SC;
  border: 1px solid#1890FF;
  border-radius: 5px 0px 0px 5px;
  &:nth-child(2) {
    border-left: none;
    border-radius: 0px 5px 5px 0px;
  }
}
.isactivetype {
  color: #ffffff;
  background-color: #1890ff;
}
.testtypebutton_content {
  width: 100%;
  min-height: 420px;
  background-color: #ffffff;
  > :nth-child(1),
  > :nth-child(2) {
    h4 {
      border-bottom: 2px solid #afd9ff;
    }
    .seriesofbtnac {
      border-bottom: 2px solid #eeeeee;
    }
  }
}
.seriesof {
  width: 100%;
  min-height: 140px;
  display: flex;
  h4 {
    width: 128px;
    min-height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 128px;
    background: #ebf6ff;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
.seriesofbtnac {
  width: calc(100% - 128px);
  padding: 45px 0px 25px 0px;
}
.seriesofbtn {
  display: inline-block;
  button {
    padding-left: 49px;
    padding-right: 49px;
    height: 50px;
    border: 1px solid #bbbbbb;
    margin-bottom: 16px;
    opacity: 1;
    border-radius: 4px;
    background-color: rgb(255, 255, 255);
    margin-left: 50px;
    color: #aaaaaa;
    font-family: PingFang SC;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      border: 1px solid #1890ff;
      background-color: #badfff;
      color: #0084ff;
    }
  }
}
.isselect {
  border: 1px solid #1890ff !important;
  background-color: #badfff !important;
  color: #0084ff !important;
}
//下面是列表的样式
.select {
  height: 42px;
  background: #1890ff;
  margin-top: 20px;
  border-radius: 10px 10px 0px 0px;
  font-size: 15px !important;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 42px !important;
  padding-left: 24px;
  color: #ffffff !important;
  text-align: left !important;
}
.question_content {
  background-color: rgb(255, 255, 255);
  padding-bottom: 60px;
}
.question_contents {
  display: flex;
  .questions {
    width: 100%;
  }
  h5 {
    height: 60px;
    font-size: 18px;
    background: #cce7ff;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    line-height: 60px;
    padding-left: 14px;
  }
}
::v-deep .is-bordered {
  > :nth-child(1) {
    min-width: 250px;
    width: 33%;
    border-right: none;
  }
  > :nth-child(2) {
    min-width: 250px;
    width: 33%;
    border-right: none;
  }
  > :nth-child(3) {
    min-width: 250px;
    width: 34%;
    border-right: none;
  }
}
::v-deep .el-cascader-menu__wrap {
  height: 430px;
}
::v-deep .el-cascader-node {
  height: 52px;
  border-bottom: 1px solid #eeeeee;
  &:focus {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
  &:hover {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
}
::v-deep .el-icon-arrow-right {
  display: none; //向右的箭头隐藏
}
::v-deep .el-cascader-menu__list {
  border-right: 1px solid #eeeeee;
}
::v-deep .in-active-path {
  //更改选中后的属性
  background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
}
.taansfer {
  > :nth-child(4) {
    background-color: #0084ff;
    display: none;
  }
}
</style>